module.exports = __webpack_public_path__ + "img/ex1.1579b2b5.png";